// import axios from "axios";
import axios from "../services/APIUtils";
import { apiConfig } from "./config";
import { parseList } from "./utility";

const ForgotPassword = async function (userName) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/ForgotPassword/${userName}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const Register = async function (model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/Register`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorCategory = async function (userName, id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/GetVendorCategories/${userName}/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const AddVendorCategory = async function (model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/AddVendorCategory`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const DeleteVendorCategory = async function (id) {
  try {
    const response = await axios.delete(
      `${apiConfig}/api/Vendor/DeleteVendorCategory/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const AddVendorLocation = async function (model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/AddVendorLocation`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorLocation = async function (userName, id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/GetVendorLocation/${userName}/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const DeleteVendorLocation = async function (id) {
  try {
    const response = await axios.delete(
      `${apiConfig}/api/Vendor/DeleteVendorLocation/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorInfo = async function (id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/GetVendorInfoByVendorID/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const UpdateVendorInfo = async function (model) {
  try {
    const response = await axios.put(
      `${apiConfig}/api/Vendor/UpdateVendorInfo`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorAttachment = async function (userName) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/getAllAttachment/${userName}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const DeleteVendorAttachment = async function (id) {
  try {
    const response = await axios.delete(
      `${apiConfig}/api/Vendor/DeleteVendorAttachment/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorExist = async (TaxId, BranchId) => {
  try {
    const url = BranchId !== undefined ? `${TaxId}/${BranchId}` : `${TaxId}`;
    const response = await axios.get(
      `${apiConfig}/api/Vendor/getVendorExist/${url}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const SubmitFileVendor = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/UploadAttachment`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const ConsentPDPA = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/ConsentPDPA`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const RequestUnlock = async function (userName) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/RequestUnlock/${userName}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const vendorservice = {
  ForgotPassword,
  Register,
  GetVendorCategory,
  AddVendorCategory,
  DeleteVendorCategory,
  AddVendorLocation,
  GetVendorLocation,
  DeleteVendorLocation,
  GetVendorInfo,
  UpdateVendorInfo,
  GetVendorAttachment,
  DeleteVendorAttachment,
  GetVendorExist,
  SubmitFileVendor,
  ConsentPDPA,
  RequestUnlock,
};
